import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Kharghartaxiservice() {



    const cardData = {

keyword: "Kharghar Taxi Services",

headingDescription:
    "Mumbai Airport Cab offers reliable and affordable Kharghar Taxi Services for local travel, airport transfers, corporate commuting, family trips, daily office travel, and outstation journeys. We provide a wide range of well-maintained vehicles including Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus with professional and experienced chauffeurs. With 24x7 availability, transparent pricing, doorstep pickup across Kharghar and Navi Mumbai, and safe travel experience, we ensure a smooth, comfortable, and hassle-free ride for every passenger.",

topPlaces: [
   
    {
        title: "Goa",
        description:
            "Goa is India’s most popular beach destination known for nightlife, beaches, water sports, and long-distance comfortable cab travel."
    },
    {
        title: "Kolhapur",
        description:
            "Kolhapur is known for Mahalaxmi Temple, cultural heritage, traditional food, and historical importance in Maharashtra."
    },
    {
        title: "Aurangabad",
        description:
            "Aurangabad is famous for Ajanta and Ellora Caves, Grishneshwar Jyotirlinga, and historical monuments attracting tourists year-round."
    },
     {
        title: "Pune",
        description:
            "Pune is a major IT and educational hub frequently visited from Kharghar for business meetings, corporate travel, and family trips via comfortable cab services."
    },
    {
        title: "Lonavala",
        description:
            "Lonavala is a popular hill station known for waterfalls, caves, valleys, and monsoon beauty, making it a top weekend getaway from Kharghar."
    },
    {
        title: "Shirdi",
        description:
            "Shirdi is a major pilgrimage destination dedicated to Sai Baba and attracts devotees from Kharghar and Navi Mumbai throughout the year."
    },
    {
        title: "Nashik",
        description:
            "Nashik is known for Trimbakeshwar Jyotirlinga, vineyards, temples, and spiritual tourism, making it a frequently booked outstation route."
    },
    {
        title: "Mahabaleshwar",
        description:
            "Mahabaleshwar is a scenic hill station famous for strawberries, viewpoints, lakes, and cool climate, ideal for family vacations."
    },
    {
        title: "Ratnagiri",
        description:
            "Ratnagiri is a beautiful Konkan coastal destination known for Ganpatipule Temple, beaches, mango farms, and scenic road trips."
    },
    {
        title: "Alibaug",
        description:
            "Alibaug is a peaceful coastal getaway near Mumbai known for beaches, sea forts, and weekend relaxation trips."
    }
],



services: [
{
name: "Cab Service in Kharghar",
description: "Cab Service in Kharghar by 1Touch Cabs provides reliable, safe, and affordable local and outstation transportation. We offer well-maintained AC vehicles including Sedan, Swift Dzire, Ertiga, Kia Carens, Innova, Innova Crysta, SUV, and Luxury Cars with professional chauffeurs. Our service ensures doorstep pickup, timely arrivals, and 24x7 availability for daily travel, airport transfers, business trips, and long-distance journeys.",
},
{
name: "Kharghar Taxi Services",
description: "Kharghar Taxi Services offers convenient and comfortable travel solutions for local and intercity routes. 1Touch Cabs ensures clean vehicles, experienced drivers, and smooth rides for families, corporate travelers, and tourists.",
},
{
name: "Kharghar Cab Service",
description: "Kharghar Cab Service provides dependable transportation for city rides, airport transfers, and outstation travel. We focus on safety, punctuality, and affordable pricing with easy booking options.",
},
{
name: "Kharghar Taxi Booking",
description: "Kharghar Taxi Booking service allows quick online and phone reservations with instant confirmation. 1Touch Cabs offers flexible vehicle selection and transparent pricing for all travel needs.",
},
{
name: "Kharghar Outstation Taxi",
description: "Kharghar Outstation Taxi service provides safe and comfortable long-distance travel to destinations like Pune, Goa, Nashik, Shirdi, and more with experienced chauffeurs and AC vehicles.",
},
{
name: "Kharghar AC Cab Service",
description: "Kharghar AC Cab Service ensures fully air-conditioned, clean, and comfortable rides for local and outstation travel, making every journey pleasant even in long-distance trips.",
},
{
name: "Kharghar Airport Taxi",
description: "Kharghar Airport Taxi service offers timely pickup and drop to Mumbai and Navi Mumbai airports with flight tracking, luggage assistance, and professional chauffeurs.",
},
{
name: "Kharghar Tourist Taxi Service",
description: "Kharghar Tourist Taxi Service provides customized sightseeing and holiday travel solutions with comfortable vehicles and knowledgeable drivers for a smooth travel experience.",
},
{
name: "Kharghar One Way Cab",
description: "Kharghar One Way Cab service offers affordable single-trip travel without return charges, ideal for budget-friendly outstation journeys.",
},
{
name: "Kharghar Outstation Cab",
description: "Kharghar Outstation Cab service provides reliable long-distance travel with safe driving, clean vehicles, and 24x7 availability for all major routes.",
},
{
name: "Kharghar Outstation Cab Service",
description: "Kharghar Outstation Cab Service ensures comfortable intercity travel with professional chauffeurs and flexible booking options for families and groups.",
},
{
name: "Kharghar One Way Outstation Cab",
description: "Kharghar One Way Outstation Cab service provides economical travel solutions for passengers traveling to other cities without return fares.",
},
{
name: "Kharghar Tourist Cab",
description: "Kharghar Tourist Cab service offers comfortable vehicles for sightseeing trips, holiday packages, and family tours with experienced drivers.",
},
{
name: "Kharghar Intercity Taxi Service",
description: "Kharghar Intercity Taxi Service provides reliable transportation between cities with safe driving and well-maintained AC vehicles for long journeys.",
},
{
name: "Kharghar Private Taxi Service",
description: "Kharghar Private Taxi Service ensures exclusive and comfortable travel with dedicated vehicles and professional chauffeurs for personal and business trips.",
},

{
name: "Kharghar to Pune Cab",
description: "Kharghar to Pune Cab service offers safe and comfortable intercity travel with multiple vehicle options including Sedan, SUV, and Innova for all travel needs.",
},
{
name: "Kharghar to Pune Cab Service",
description: "Kharghar to Pune Cab Service provides reliable transportation with experienced drivers and smooth highway travel for families and corporate passengers.",
},
{
name: "Kharghar to Pune Taxi",
description: "Kharghar to Pune Taxi service ensures affordable and comfortable travel with door-to-door pickup and drop facility.",
},
{
name: "Kharghar to Pune Taxi Service",
description: "Kharghar to Pune Taxi Service offers safe, timely, and professional intercity travel with clean vehicles and trained chauffeurs.",
},
{
name: "Kharghar to Pune One Way Cab",
description: "Kharghar to Pune One Way Cab service provides cost-effective travel without return charges, ideal for solo and business travelers.",
},
{
name: "Kharghar to Pune Outstation Cab",
description: "Kharghar to Pune Outstation Cab service ensures smooth and safe highway travel with flexible booking options and comfortable vehicles.",
},

{
name: "Kharghar to Goa Cabs",
description: "Kharghar to Goa Cabs service provides long-distance travel with well-maintained vehicles, professional drivers, and 24x7 availability for a comfortable Goa trip.",
},
{
name: "Kharghar to Goa Cab Service",
description: "Kharghar to Goa Cab Service offers reliable intercity travel with multiple vehicle options including SUV, Innova, and Luxury Cars for family and group trips.",
},
{
name: "Kharghar to Goa Taxi",
description: "Kharghar to Goa Taxi service ensures safe and affordable long-distance transportation with experienced chauffeurs and AC vehicles.",
},
{
name: "Kharghar to Goa Taxi Service",
description: "Kharghar to Goa Taxi Service provides comfortable and reliable travel with doorstep pickup, smooth highway driving, and 24x7 booking support."
}
],

tableData: [
["Cab Service in Kharghar","Kharghar Taxi Services"],
["Kharghar Cab Service","Kharghar Taxi Booking"],
["Kharghar Outstation Taxi","Kharghar AC Cab Service"],
["Kharghar Airport Taxi","Kharghar Tourist Taxi Service"],
["Kharghar One Way Cab","Kharghar Outstation Cab"],
["Kharghar Outstation Cab Service","Kharghar Intercity Taxi Service"],
["Kharghar to Pune Cab","Kharghar to Pune Taxi Service"],
["Kharghar to Pune One Way Cab","Kharghar to Goa Cabs"],
["Kharghar to Goa Cab Service","Kharghar to Goa Taxi"]
],




















whychoose: [
    {
        WhyChooseheading: "Reliable Taxi Services in Kharghar",
        WhyChoosedescription: "Mumbai Airport Cabs provides dependable taxi services in Kharghar for local travel, airport transfers, corporate transportation, outstation journeys, sightseeing tours, and daily commuting."
    },
    {
        WhyChooseheading: "24x7 Cab Availability",
        WhyChoosedescription: "Our taxi services are available round the clock, making it convenient for airport travel, business meetings, family functions, emergency trips, and late-night transportation."
    },
    {
        WhyChooseheading: "Local and Outstation Travel Solutions",
        WhyChoosedescription: "Book taxis from Kharghar to Mumbai Airport, Navi Mumbai Airport, Pune, Lonavala, Shirdi, Nashik, Mahabaleshwar, Goa, Kolhapur, and other destinations."
    },
    {
        WhyChooseheading: "Wide Range of Vehicle Options",
        WhyChoosedescription: "Choose from Swift Dzire, Ertiga, Innova, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, Mini Buses, and premium vehicles according to your travel requirements."
    },
    {
        WhyChooseheading: "Airport Pickup and Drop Specialists",
        WhyChoosedescription: "We provide comfortable and punctual airport transfers for Mumbai Airport and Navi Mumbai International Airport with professional chauffeurs and timely pickups."
    },
    {
        WhyChooseheading: "Experienced Drivers and Safe Travel",
        WhyChoosedescription: "Our trained drivers ensure safe driving, route expertise, punctual service, and a smooth travel experience throughout the journey."
    },
    {
        WhyChooseheading: "Doorstep Pickup Across Kharghar",
        WhyChoosedescription: "Pickup services are available from Sector 10, Sector 11, Sector 12, Sector 20, Sector 35, Central Park, Kharghar Railway Station, and all nearby areas."
    },
    {
        WhyChooseheading: "Ideal for Families, Tourists, and Corporate Clients",
        WhyChoosedescription: "From local city rides and airport transfers to corporate travel and outstation tours, we provide transportation solutions for every requirement."
    }
]
};

const faqData = [
    {
        question: "What services are included in Kharghar Taxi Services?",
        answer: "We provide local taxi services, airport transfers, outstation travel, corporate transportation, sightseeing tours, employee transport, and customized travel solutions."
    },
    {
        question: "Can I book a taxi for Mumbai Airport transfers?",
        answer: "Yes, airport pickup and drop services are available for Mumbai Airport and Navi Mumbai International Airport."
    },
    {
        question: "Which vehicles are available for booking?",
        answer: "Swift Dzire, Ertiga, Innova, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, Mini Buses, and premium vehicles are available."
    },
    {
        question: "Do you provide outstation taxi services from Kharghar?",
        answer: "Yes, outstation taxi services are available for Pune, Nashik, Shirdi, Lonavala, Mahabaleshwar, Goa, Kolhapur, Ahmedabad, and many other destinations."
    },
    {
        question: "Can corporate clients use your taxi services regularly?",
        answer: "Yes, we provide transportation solutions for executives, employees, business travelers, and corporate organizations."
    },
    {
        question: "Are Tempo Travellers available for group travel?",
        answer: "Yes, Tempo Travellers and Mini Buses are available for family tours, weddings, corporate outings, educational trips, and group transportation."
    },
    {
        question: "Can I schedule a taxi in advance?",
        answer: "Yes, advance booking is recommended to secure your preferred vehicle and travel schedule."
    },
    {
        question: "Do you provide Kharghar sightseeing taxi services?",
        answer: "Yes, customers can book taxis for Central Park, Pandavkada Waterfalls, Golf Course, ISKCON Temple, and nearby attractions."
    },
    {
        question: "Are your drivers experienced and verified?",
        answer: "Yes, all drivers are professionally trained, experienced, and familiar with local as well as outstation travel routes."
    },
    {
        question: "How can I book a Taxi Service in Kharghar?",
        answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Rahul Patil",
        feedback:
            "Excellent cab service from start to finish. The vehicle was clean, the driver was courteous, and the journey was extremely comfortable.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Sneha Mehta",
        feedback:
            "The travel experience exceeded our expectations. Timely pickup, smooth driving, and professional service made the trip enjoyable.",
        rating: 5
    }
];


















   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Kharghar Taxi Services",
  "image": "https://www.mumbaiairportcabs.com/assets/images/kharghar-taxi-service.jpg",
  "description": "Book Kharghar taxi service for safe, reliable, and comfortable local and outstation travel. Mumbai Airport Cabs offers 24x7 cab booking, professional drivers, clean AC vehicles, and affordable pricing for all travel needs.",
  "brand": {
    "@type": "Brand",
    "name": "Mumbai Airport Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "5400"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹10/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.mumbaiairportcabs.com/kharghar-taxi-services"
  }
};





    return (
        <div>



<Helmet>
  <title>Kharghar Taxi Services | Reliable Cab Booking | +91 9545731161</title>

  <meta
    name="description"
    content="Book Kharghar taxi service for local and outstation travel. Affordable cab booking with professional drivers and 24x7 availability."
  />

  <meta
    name="keywords"
    content="cab service in kharghar, Kharghar Taxi Services, Kharghar Cab Service, Kharghar Taxi Booking, Kharghar Outstation Taxi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>







            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/3.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Kharghartaxiservice;